import { render } from "./VetData.vue?vue&type=template&id=74d38afe&scoped=true&ts=true"
import script from "./VetData.vue?vue&type=script&lang=ts"
export * from "./VetData.vue?vue&type=script&lang=ts"

import "./VetData.vue?vue&type=style&index=0&id=74d38afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d38afe"]])

export default __exports__